<template>
  <div id="boards">
    <div
      class="no-boards"
      v-if="boards.length === 0 && !onArchivedPage"
    >Make some boards and get projecting!</div>

    <ul>
      <li v-for="board in boards" :key="board.board_id">
        <BoardItem :board="board" />
      </li>
      <li v-for="sharedBoard in sharedBoards" :key="sharedBoard.board_id">
        <BoardItem :board="sharedBoard" />
      </li>
    </ul>
  </div>
</template>

<script>
import BoardItem from "@/components/BoardItem";

export default {
  name: "Boards",
  components: { BoardItem },
  props: ["boards", "sharedBoards"],
  computed: {
    onArchivedPage() {
      return this.$route.name === "archived";
    }
  }
};
</script>
